/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MoveToTop = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 8.75H18V7.25H6V8.75ZM7 14.3289L8.09835 15.3519L11.2002 12.25V19.9863H12.7002V12.25L15.8021 15.3519L16.9004 14.3289L13.0109 10.4393C12.4251 9.85355 11.4753 9.85355 10.8896 10.4393L7 14.3289Z"
                        fill={color}
                    />
                </svg>
        );
    };
